<mat-card>
    <mat-card-content>
        <mat-toolbar color="primary">Contatos</mat-toolbar>
        <div class="flex-item">
            <div class="campo-dados" *ngIf="contato.nmFilial">
                <strong> Filial:</strong> 
                <span>{{contato.nmFilial}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="campo-dados" *ngIf="contato.nmCidade">
                <strong>Cidade: </strong> 
                <span>{{contato.nmCidade}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="campo-dados" *ngIf="contato.uf">
                <strong> Estado:</strong> 
                <span>{{contato.uf}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="campo-dados" *ngIf="contato.bairro">
                <strong>Bairro: </strong> 
                <span>{{contato.bairro}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="campo-dados" *ngIf="contato.telefoneFilial">
                <strong>Telefone filial: </strong> 
                <span>{{contato.telefoneFilial}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="campo-dados" *ngIf="contato.nmFuncionario">
                <strong>Vendedor: </strong> 
                <span>{{contato.nmFuncionario}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="campo-dados" *ngIf="contato.telefoneFixoComercial">
                <strong>Telefone: </strong> 
                <span>{{formataCelular(contato.telefoneFixoComercial)}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="campo-dados" *ngIf="contato.emailComercial">
                <strong>Email: </strong> 
                <span>{{contato.emailComercial}}</span>
            </div>
            <mat-divider></mat-divider>
            <div class="campo-dados" *ngIf="contato.celularComercial">
                <strong>Celular: </strong> 
                <span>{{formataCelular(contato.celularComercial)}}</span>
            </div>
        </div>
    </mat-card-content>
</mat-card>
  